import React from 'react';
import CheckContentWrapper, { PageType } from '../../common/check-content-wrapper';
import { GroupsCarousel } from './carousel';

type GroupsBodyProps = {
  activeTabIndex: number;
  setActiveTabIndex: (value: number) => void;
};

export const GroupsBody: React.FC<GroupsBodyProps> = ({ activeTabIndex, setActiveTabIndex }) => (
  <CheckContentWrapper page={PageType.Groups}>
    <GroupsCarousel activeTabIndex={activeTabIndex} setActiveTabIndex={setActiveTabIndex} />
  </CheckContentWrapper>
);
